"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidBrandIdentificationTypeEnum = void 0;
var ValidBrandIdentificationTypeEnum;
(function (ValidBrandIdentificationTypeEnum) {
    ValidBrandIdentificationTypeEnum["TEXT"] = "instant_text";
    ValidBrandIdentificationTypeEnum["HASHTAG"] = "instant_hashtags";
    ValidBrandIdentificationTypeEnum["AT_SIGN"] = "instant_at_sign";
    ValidBrandIdentificationTypeEnum["COSINE_SIMILARITY"] = "cosine_similarity";
})(ValidBrandIdentificationTypeEnum = exports.ValidBrandIdentificationTypeEnum || (exports.ValidBrandIdentificationTypeEnum = {}));
//# sourceMappingURL=validBrandIdentificationType.enum.js.map